import { Button } from "primereact/button";
import { JVDate } from "../../shared/JVDate";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { IBranchMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { MultiSelect } from "primereact/multiselect";
import { JVInput } from "../../shared/JVInput";

export interface IFilterTimesheet {
    month?: Date | null,
    status?: string | null,
    consultant?: { consultant_ID: number, consultant_Name: string } | null,
    consultant_Name?: string | null,
    consultant_Email_ID?: string | null,
    companyName?: IClientCompanyDropdown | null,
    companyName2?: IClientCompanyDropdown | null,
    vendor_Company_Name?: string | null,
    sub_Vendor_Company?: string | null,
    companyIDs?: number[] | null,
    branchIDs?: number[] | null,
}

export const EmptyFilterTimesheet: IFilterTimesheet = {
    month: new Date(),
    status: null,
    consultant: null,
    consultant_Name: null,
    consultant_Email_ID: null,
    companyName: null,
    companyName2: null,
    vendor_Company_Name: null,
    companyIDs: null,
    branchIDs: null,
};

interface IProps {
    singleData: IFilterTimesheet,
    setFilterData: (filterData: IFilterTimesheet) => void,
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    status: yup.string().nullable(),
    consultant: yup.object().shape({
        consultant_ID: yup.number().nullable(),
        consultant_Name: yup.string().nullable()
    }).nullable(),
    consultant_Email_ID: yup.string().nullable(),
    companyName: yup.object().shape({
        vendor_Company_ID: yup.number().nullable(),
        vendor_Company_Name: yup.string().nullable()
    }).nullable(),
    companyName2: yup.object().shape({
        vendor_Company_ID: yup.number().nullable(),
        vendor_Company_Name: yup.string().nullable()
    }).nullable(),
});

export const Filter = (props: IProps) => {
    const [consultant, setConsultant] = useState<Array<any>>();
    const [vendorCompanies, setVendorCompanies] = useState<Array<IClientCompanyDropdown>>([]);
    const [primeVendorCompany, setPrimeVendorCompany] = useState<Array<IClientCompanyDropdown>>([]);
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [selectedSBranch, setSelectedSBranch] = useState<Array<number>>([]);
    const [selectedCompany, setSelectedCompany] = useState<Array<number>>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IFilterTimesheet>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        loadConsultant(event.query);
    };

    const onSubmit = (data: IFilterTimesheet) => {
        data.companyIDs = selectedCompany;
        data.branchIDs = selectedSBranch;
        props.setFilterData(data);
    };

    const loadVendorCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setVendorCompanies(data);
        }
    }

    const searchSub = (event: { query: string }) => {
        loadVendorCompanies(event.query);
    }

    const loadPrimeVendorCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies_Form", "GET", null, `filter='${filter}'`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setPrimeVendorCompany(data);
        }
    }

    const searchPrime = (event: { query: string }) => {
        loadPrimeVendorCompanies(event.query);
    }

    const loadCompanies = async () => {
        const response = await Fetch(`Dropdown/reqCompanyList`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const loadBranches = async (company: number[] | null) => {
        let queryParam = company !== null && company.length >= 1 ? `company_id=${company.join(",")}` : null;

        const response = await Fetch("Dropdown/multiCompbranches", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }

    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        loadBranches(selectedCompany);
    }, [selectedCompany]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDate column={6} maxDate={new Date()} label="Month & Year" type="month-year" control={control} name="month" />
                <div className="field col-2 md:col-2">
                    <p>Company</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedCompany} onChange={(e) => setSelectedCompany(e.value)} options={companies} optionValue="company_ID" optionLabel="company_Name" display="chip" filter placeholder="Select Company" />
                </div>
                <div className="field col-2 md:col-2">
                    <p>Branch</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedSBranch} onChange={(e) => setSelectedSBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
                </div>
                <JVDropdownInput column={6} label="Consultant Name" completeMethod={completeMethodConsultant} control={control} name="consultant" options={consultant} optionLabel="consultant_Name" placeholder="Search " />
                <JVInput column={6} label="Consultant Email" control={control} name="consultant_Email_ID" error={errors.consultant_Email_ID?.message} placeholder="Enter Consultant Email" />
                <JVDropdownInput column={6} completeMethod={searchSub} label="Sub Vendor Company" control={control} name="companyName" options={vendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search Sub Vendor Company" />
                <JVDropdownInput column={6} completeMethod={searchPrime} label="Prime Vendor Company" control={control} name="companyName2" options={primeVendorCompany} optionLabel="vendor_Company_Name" placeholder="Search Prime Vendor Company" />

                <div style={{ margin: '10px 0', width: '100%' }}></div>

                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => {
                        reset(EmptyFilterTimesheet);
                        setSelectedCompany([]);
                        setSelectedSBranch([]);
                    }} type="button"></Button>
                </div>
            </form>
        </>
    );
}